export default __webpack_public_path__ + "static/media/checked-green.fc136ca4.svg";